export function rand(faces: number): number {
  return Math.floor(Math.random() * faces) + 1;
}
